import { useForm } from '@tanstack/react-form'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { notFound, useNavigate } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'
import { Request } from 'commons/utils/request'
import { useConfirmation } from 'ui/components/Dialog/ConfirmationDialogV2'

import { useSaveSourceAndFilesManage } from '../../hooks'
import { BankSourceSetupForm, BankSourceSetupMode } from '../../types'

export const useBankSourceCreate = (MRId: number, licenseId: number, type?: string) => {
  const navigate = useNavigate()
  const confirmation = useConfirmation()
  const payload: Record<string, any> = {
    licenseId
  }

  if (type === 'custom') {
    payload.reportCustomId = MRId
  } else {
    payload.reportMonthlyId = MRId
  }

  const { data, isFetched } = useQuery<BankSourceSetupMode>({
    queryKey: ['bank-source-setup-mode'],
    queryFn: () => Request.post(Request.urls.bank.salesDataBankSourceSetupMode, payload),
    staleTime: 1000,
    placeholderData: keepPreviousData
  })

  const defaultValues = { ...data?.form } as BankSourceSetupForm

  const formApi = useForm({
    defaultValues
  })

  const { onSubmit, isSubmitting, isFileUploading, files, addFiles, deleteFile } = useSaveSourceAndFilesManage(
    undefined,
    MRId,
    formApi,
    type === 'custom'
  )

  const openSubmitConfirm = async () => {
    await confirmation.showAskConfirmation({
      message: (
        <>
          Are you sure you want to proceed?
          <br />
          Manual Sales Data Override will become the primary Sales Data source.
        </>
      ),
      submitButtonText: 'Confirm',
      confirmCallback: () => onSubmit()
    })
  }

  const onCancel = () => {
    if (type === 'custom') {
      navigate({ to: routes.bank.hrr.details, params: { id: MRId.toString() } })
    } else {
      navigate({ to: '/mr/$id', params: { id: MRId.toString() } })
    }
  }

  if (isFetched && !data) {
    throw notFound()
  }

  return {
    data,
    onCancel,
    openSubmitConfirm,
    // SubmitConfirmation,
    isSubmitting: isSubmitting || isFileUploading,
    files,
    addFiles,
    deleteFile,
    formApi
  }
}
